// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBTyighsEUXVcWgWQgUYfs3uiNdTbUJ2-o",
  authDomain: "jdsofttechportfolio.firebaseapp.com",
  projectId: "jdsofttechportfolio",
  storageBucket: "jdsofttechportfolio.firebasestorage.app",
  messagingSenderId: "682623763675",
  appId: "1:682623763675:web:00113bab6b42a6b9c6b8fe",
  measurementId: "G-VTP782E85M",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
